<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-content-scroll" [hidden]="minimise">
  <!-- Spacer -->
  <table class="spacer-table">
    <tr><td>&nbsp;</td></tr>
  </table>

  <!-- Entity Details Table -->
  <div class="entity-details-container">
    <table class="table table-bordered entityDetails">
      <tr>
        <td><b>Tax Year</b></td>
        <td><b>LEID</b></td>
        <td><b>LE Name</b></td>
      </tr>
      <tr>
        <td>{{ tax_year }}</td>
        <td>{{ leid }}</td>
        <td>{{ le_name }}</td>
      </tr>
    </table>
  </div>

  <!-- Table Header -->
  <div class="table-scroll-head">
    <table class="table table-no-bottom-margin table-bordered">
      <tr>
        <th class="col-line">Line</th>
        <th class="col-desc">Line Description</th>
        <th class="col-entity">Entity Name</th>
        <th class="col-amount">Amount</th>
      </tr>
    </table>
  </div>

  <!-- Modal Body -->
  <div class="modal-body slim-scroll-block">
    <!-- Loading Spinner -->
    @if (showFormLoader) {
<div class="loading-container">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
}

    <!-- No Data Message -->
    @if (!showFormLoader && (!K_K1_array || K_K1_array.length === 0)) {
<div 
         style="padding: 20px; text-align: center; color: #666;">
      No Schedule K data available.
    </div>
}

    <!-- Data Table -->
    @if (!showFormLoader && K_K1_array.length > 0) {
<table class="table table-no-border form-inline">
      @for (k1tabularRec of K_K1_array; track $index) {
<tr>
        <td class="no-border-top">
          <table class="table table-bordered form-inline">
            @for (row of k1tabularRec; track $index; let i = $index) {
<tr>
              <!-- Line Number Column -->
              @if (isFirstRow(i)) {
<td class="no-border-bottom" style="width: 5%;">
                <b>{{ row.LINE_NO }}</b>
              </td>
}
              @if (!isFirstRow(i)) {
<td class="no-border-top-bottom" style="width: 5%;"></td>
}

              <!-- Line Description Column -->
              @if (isFirstRow(i)) {
<td class="col-desc no-border-bottom">
                <b>{{ row.LINE_DESCRIPTION }}</b>
              </td>
}
              @if (!isFirstRow(i)) {
<td class="col-desc no-border-top-bottom"></td>
}

              <!-- Entity Name Column -->
              @if (isFirstRow(i)) {
<td class="col-entity">
                <b>{{ row.LE_NAME }}</b>
              </td>
}
              @if (isEntityRow(row)) {
<td class="col-entity">
                {{ row.LEID }} - {{ row.LE_NAME }}
              </td>
}
              @if (isTotalRow(row)) {
<td class="col-entity">
                <b>Total</b>
              </td>
}
              @if (isVarianceRow(row)) {
<td class="col-entity">
                <b>Variance</b>
              </td>
}

              <!-- Amount Column -->
              @if (isFirstRow(i)) {
<td class="col-amount text-right padding-value">
                <b>{{ row.ADJ_AMT_1 | number }}</b>
              </td>
}

              <!-- Editable input for entity rows -->
              @if (isEditableRow(row)) {
<td class="col-amount">
                <input type="text"
                       onlyIntegersWithLength
                       [(ngModel)]="row.ADJ_AMT_1"
                       class="form-control input-sm numText text-right"
                       (ngModelChange)="setChange(row)" />
              </td>
}

              <!-- Conditionally editable input (20A/20B with K1 exists) -->
              @if (isConditionalEditableRow(row)) {
<td class="col-amount">
                <input type="text"
                       onlyIntegersWithLength
                       [(ngModel)]="row.ADJ_AMT_1"
                       class="form-control input-sm numText text-right"
                       (ngModelChange)="setChange(row)" />
              </td>
}

              <!-- Disabled input (20A/20B without K1) -->
              @if (isDisabledRow(row)) {
<td class="col-amount">
                <input type="text"
                       onlyIntegersWithLength
                       [(ngModel)]="row.ADJ_AMT_1"
                       class="form-control input-sm numText text-right"
                       disabled />
              </td>
}

              <!-- Total row display -->
              @if (isTotalRow(row)) {
<td class="col-amount text-right padding-value">
                <b>{{ row.ADJ_AMT_1 | number }}</b>
              </td>
}

              <!-- Variance row display -->
              @if (isVarianceRow(row)) {
<td class="col-amount text-right padding-value">
                <b>
                  <span [ngClass]="{'show-red-text': isNegativeVariance(row.ADJ_AMT_1)}">
                    {{ formatVariance(row.ADJ_AMT_1) }}
                  </span>
                </b>
              </td>
}
            </tr>
}
          </table>
        </td>
      </tr>
}
    </table>
}
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (canShowSaveButton()) {
<button class="btn btn-info btn-sm save-button" 
          type="button" 
         
          (click)="save()" 
          [disabled]="isSaving">
    @if (isSaving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save and Proceed
  </button>
}
  <button class="btn btn-warning btn-sm cancel-button" 
          type="button" 
          (click)="cancel()">
    Cancel
  </button>
</div>
